module.exports = __webpack_public_path__ + "fonts/d5ea405c-2180-4ff0-bd51-3e19fb280be4.59e16de1.ttf";